import CodeMirror from '@uiw/react-codemirror'
import { ReactComponent as CloseIcon } from 'assets/icons/close24.svg'
import { ReactComponent as InfoIcon } from 'assets/icons/info16.svg'
import cx from 'classnames'
import { Button } from 'components/Button'
import mermaid from 'mermaid'
import { useLayoutEffect, useRef, useState } from 'react'
import Styles from './EditMermaidModal.module.scss'

const MERMAID_HELP_URL = 'https://mermaid-js.github.io/mermaid/#/'

interface Props {
  code: string
  updateAttributes: (updatedAttrs: Record<string, any>) => void
  closeModal: () => void
}

export const EditMermaidModalCloseIcon = () => (
  <div className={Styles.closeIconContainer}>
    <CloseIcon />
  </div>
)

export const EditMermaidModal = ({ code, updateAttributes, closeModal }: Props) => {
  const [codeText, setCodeText] = useState(
    code ||
      `graph TD;
    A-->B;
    A-->C;
    B-->D;
    C-->D;`,
  )
  const [codemirrorText, setCodemirrorText] = useState(codeText)
  const previewRef = useRef<HTMLDivElement | null>(null)

  const updateClick = () => {
    setCodeText(codemirrorText)
  }

  useLayoutEffect(() => {
    delete previewRef.current?.dataset.processed

    setTimeout(() => {
      if (previewRef.current) {
        mermaid.run()
      }
    })
  }, [codeText])

  return (
    <div>
      <div className={Styles.container}>
        <div className={Styles.leftColumn}>
          <div className={Styles.label}>Markup</div>
          <div className={Styles.codeMirrorContainer}>
            <CodeMirror
              value={codemirrorText}
              height={'300px'}
              onChange={(value) => {
                setCodemirrorText(value)
              }}
            />
          </div>
          <div className={Styles.codeActionBar}>
            <div /> {/* placeholder for background color select */}
            <Button onClick={updateClick} variant="tertiary" size="lg" className={Styles.updateButton}>
              Update Diagram →
            </Button>
          </div>
        </div>
        <div className={Styles.rightColumn}>
          <div ref={previewRef} className={cx(Styles.preview, 'mermaid')}>
            {codeText}
          </div>
        </div>
      </div>
      <div className={Styles.footer}>
        <a href={MERMAID_HELP_URL} target="_blank" rel="noreferrer">
          <div className={Styles.helpText}>
            <InfoIcon />
            What is Mermaid.js?
          </div>
        </a>
        <div>
          <Button onClick={() => closeModal()} size="lg" variant="secondaryGrey" className={Styles.cancelButton}>
            Cancel
          </Button>
          <Button
            size="lg"
            className={Styles.saveButton}
            onClick={() => {
              updateAttributes({ code: codemirrorText })
              closeModal()
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  )
}
